module.exports = __webpack_public_path__ + "media/images/logo/payment_channel/atm_bersama-a8e0e6ed7fe9174a99c4df0d4ef22927.svg";